// frontend/src/components/TrialExpiredModal.jsx
import { useEffect, useState } from "react";

/**
 * Modal that displays when a tenant's trial has expired.
 *
 * This component listens for 403 responses with title="trial_expired"
 * and shows a blocking modal that prevents access to the application.
 */
export default function TrialExpiredModal() {
  const [isExpired, setIsExpired] = useState(false);
  const [trialEndDate, setTrialEndDate] = useState(null);

  useEffect(() => {
    // Intercept fetch responses globally
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);

      // Clone response so we can read it without consuming it
      const clone = response.clone();

      if (response.status === 403) {
        try {
          const data = await clone.json();
          if (data.title === "trial_expired") {
            setIsExpired(true);
            setTrialEndDate(data.trial_ends_at || null);
          }
        } catch (e) {
          // Not JSON or couldn't parse, ignore
        }
      }

      return response;
    };

    // Cleanup
    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  if (!isExpired) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.85)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
      }}>
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "2rem",
          maxWidth: "500px",
          width: "90%",
          boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
        }}>
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              fontSize: "3rem",
              marginBottom: "1rem",
            }}>
            ⏰
          </div>
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              marginBottom: "1rem",
              color: "#111827",
            }}>
            Trial Period Ended
          </h2>
          <p
            style={{
              color: "#6B7280",
              marginBottom: "0.5rem",
              fontSize: "1rem",
            }}>
            Your trial period has expired.
          </p>
          {trialEndDate && (
            <p
              style={{
                color: "#9CA3AF",
                fontSize: "0.875rem",
                marginBottom: "1.5rem",
              }}>
              Trial ended: {new Date(trialEndDate).toLocaleDateString()}
            </p>
          )}
          <p
            style={{
              color: "#374151",
              marginBottom: "2rem",
              lineHeight: "1.5",
            }}>
            To continue using CBCFX, please contact our support team to activate your subscription.
          </p>
          <div style={{ display: "flex", gap: "1rem", justifyContent: "center" }}>
            <a
              href="mailto:support@cbcfx.site"
              style={{
                display: "inline-block",
                backgroundColor: "#3B82F6",
                color: "white",
                padding: "0.75rem 1.5rem",
                borderRadius: "6px",
                textDecoration: "none",
                fontWeight: "500",
                transition: "background-color 0.2s",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#2563EB")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#3B82F6")}>
              Contact Support
            </a>
            <button
              onClick={() => window.location.reload()}
              style={{
                backgroundColor: "#F3F4F6",
                color: "#374151",
                padding: "0.75rem 1.5rem",
                borderRadius: "6px",
                border: "none",
                fontWeight: "500",
                cursor: "pointer",
                transition: "background-color 0.2s",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#E5E7EB")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#F3F4F6")}>
              Refresh Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
